import React, {useState} from 'react';
import PrivacyPolicy from "./PrivacyPolicy";


const CookieFooter = () => {
    const isCookiePopupShown = localStorage.getItem("isCookiePopupShown");
    const [isCookiePopupVisible, setIsCookiePopupVisible] = useState(true);
    const [open, setOpen] = useState(false);

    const onClose = () => {
        localStorage.setItem("isCookiePopupShown", "true");
        setIsCookiePopupVisible(false);
    }

    const onOpen = () => {
        setOpen(true);
    }

    const handleOk = () => {
        setOpen(false);
        onClose();
    }

    const closeModal = () => {
        setOpen(false);
    }

    return (
        isCookiePopupVisible && !isCookiePopupShown &&
        (<>
            <style>
                {`
        .floating-footer {
          position: fixed;
          left: 1rem;
          right: 5rem;
          bottom: 1rem;
          background: #fff;
          color: black;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          padding: 1.5rem;
          z-index: 100;
          box-shadow: 0 -2px 6px rgba(0,0,0,0.2);
          font-size: 14px;
          line-height: 1;
          border-radius: 5px;
          margin: 5px;
          flex-direction: column;
          width: 300px;
          gap: 1rem;
        }
        
        .floating-footer__content {
          display: flex;
          font-size: 0.9rem;
          align-items: center;
        }
        
        .floating-footer__link {
          color: rgb(219, 35, 22);
          margin-left: 6px;
        }
        
        .floating-footer__link:hover{
          color: rgb(219, 35, 22);
          text-decoration: underline;
        }
        
        .floating-footer__close {
          
          background: #3a3a3a;
          color: #fff;
          border: none;
          padding: 6px 10px;
          border-radius: 3px;
          cursor: pointer;
          font-weight: 600;
        }
        
        @media (max-width: 480px) {
          .floating-footer {
            padding: 8px;
            font-size: 13px;
          }
          
          .floating-footer__close {
            padding: 6px 8px;
            margin-left: 10px;
          }
        }
      `}
            </style>
            <PrivacyPolicy handleOk={handleOk} open={open} closeModal={closeModal} />
            <div className="floating-footer" role="region" aria-label="cookie-info">
                <img src={"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='96' height='96' viewBox='0 0 96 96'%3E%3Cpath d='M35 45.5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zM63.5 63a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm-19 19a7.5 7.5 0 100-15 7.5 7.5 0 000 15z' opacity='.2' fill='%23379fef'%3E%3C/path%3E%3Cpath d='M56.99 2.53a23.1 23.1 0 0114.66 6.15h.01l.01.02c.57.55.61 1.27.5 1.74v.07a10.95 10.95 0 01-3.07 4.77 9 9 0 01-6.9 2.5 10.34 10.34 0 01-9.72-10.44v-.08a10 10 0 011.03-3.74l.01-.03.02-.02c.28-.5.82-.92 1.52-.95.63-.02 1.27-.02 1.93.01zm12.04 7.83a20.1 20.1 0 00-12.2-4.83l-.92-.03c-.23.6-.38 1.25-.43 1.94a7.34 7.34 0 006.95 7.34 6 6 0 004.64-1.7c.94-.88 1.6-1.9 1.96-2.72zm15.3 8.76a6.84 6.84 0 00-5.09-.24 7.9 7.9 0 00-3.28 2.05 1.8 1.8 0 00-.3 1.95l.02.02v.02a15.16 15.16 0 008.74 7.47c.64.23 1.32.08 1.8-.33a6.63 6.63 0 001.63-1.97l.01-.03.01-.03c1.67-3.5-.12-7.32-3.54-8.91zm-5.5 3.28c.36-.25.82-.5 1.35-.67.92-.3 1.92-.35 2.89.1 2.14 1 2.92 3.14 2.11 4.88-.12.21-.26.41-.43.6l-.26-.1a12.29 12.29 0 01-5.66-4.81zM32 24a2 2 0 11-4 0 2 2 0 014 0zm12 21a2 2 0 11-4 0 2 2 0 014 0zm36 4a2 2 0 11-4 0 2 2 0 014 0zm-7 21a2 2 0 11-4 0 2 2 0 014 0zM59 81a2 2 0 11-4 0 2 2 0 014 0zM22 63a2 2 0 11-4 0 2 2 0 014 0zm27 7a9 9 0 11-18 0 9 9 0 0118 0zm-3 0a6 6 0 10-12 0 6 6 0 0012 0zM33 41a9 9 0 11-18 0 9 9 0 0118 0zm-15 0a6 6 0 1012 0 6 6 0 00-12 0zm50 11a9 9 0 11-18 0 9 9 0 0118 0zm-3 0a6 6 0 10-12 0 6 6 0 0012 0zM44.08 4.24c.31.48.33 1.09.05 1.58a17.46 17.46 0 00-2.36 8.8c0 9.55 7.58 17.24 16.85 17.24 2.97 0 5.75-.78 8.16-2.15a1.5 1.5 0 012.1.66 12.08 12.08 0 0011 6.74 12.4 12.4 0 007.85-2.75 1.5 1.5 0 012.38.74A45.76 45.76 0 0192 48.16c0 24.77-19.67 44.9-44 44.9S4 72.93 4 48.16C4 25.23 20.84 6.28 42.64 3.58a1.5 1.5 0 011.44.66zM40.22 7C21.32 10.71 7 27.7 7 48.16c0 23.17 18.39 41.9 41 41.9s41-18.73 41-41.9c0-3.52-.42-6.93-1.22-10.2a15.5 15.5 0 01-7.9 2.15c-5.5 0-10.36-2.83-12.97-7.1a19.46 19.46 0 01-8.28 1.85c-11 0-19.86-9.1-19.86-20.24 0-2.7.52-5.26 1.45-7.62zM92 91a2 2 0 100-4 2 2 0 000 4zM7 8.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM82.5 90a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm9.5-7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM13.5 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM80 14.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM53.5 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3z' fill='%23379fef'%3E%3C/path%3E%3C/svg%3E"} />
                <div className="floating-footer__content">
                    <span>This site uses cookies. To see how cookies are used, please review our<a onClick={onOpen} className="floating-footer__link">privacy policy</a></span>
                </div>
                <button
                    type="button"
                    className="floating-footer__close"
                    aria-label="Dismiss cookie message"
                    onClick={onClose}
                >
                    OK
                </button>
            </div>
        </>)
    );
};

export default CookieFooter;